import { Fragment, useState } from 'react';
import { Page } from '../theme/elements/Page';
import { WarningDialog } from 'components/WarningDialog';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { clearError, getWebhookMonitoringError } from 'state/reducers/webhook-monitoring.reducer';
import { useAppDispatch } from 'hooks/redux.hooks';
import { useParams } from 'react-router-dom';
import { MonitoringFilters, MonitoringTable } from 'sections/WebhookMonitoring';
import { Stack } from '@mui/material';
import { pagesEnum } from 'constants/ui.constants';
import { WebhookMonitoringStatusBucket } from 'constants/webhook-monitoring.constants';

const webhookMonitoringStatusBucketValues = Object.values(WebhookMonitoringStatusBucket) as string[];

const parseWebhookMonitoringStatusParam = (param: string | undefined): WebhookMonitoringStatusBucket => {
	if (param && webhookMonitoringStatusBucketValues.includes(param)) {
		return param as WebhookMonitoringStatusBucket;
	}
	return WebhookMonitoringStatusBucket.Active;
};

export const WebhookOperationsTableApp = () => {
	const dispatch = useAppDispatch();
	const { status: statusParam } = useParams();
	const status = parseWebhookMonitoringStatusParam(statusParam);
	const t = useAppSelector(selectTranslations);
	const error = useAppSelector(getWebhookMonitoringError);
	const [filters, setFilters] = useState<Record<string, any>>({});

	const basePath = `/${pagesEnum.WEBHOOK_MONITORING}`;

	return (
		<Fragment>
			<Page
				title={t(`page.webhookMonitoring.table.${status}.title`)}
				includeGoBack
				goBackUrl={`${basePath}/${pagesEnum.WEBHOOK_OPERATIONS_DASHBOARD}`}
			>
				<WarningDialog
					open={error.exist}
					subTitle={error.text ? t(error.text) : ''}
					handleCancel={() => dispatch(clearError())}
				/>
				<Stack spacing={4}>
					<MonitoringFilters filters={filters} setFilters={setFilters} />
					<MonitoringTable
						status={status}
						filters={filters}
						title={t(`page.webhookMonitoring.table.${status}.title`)}
						includeWebhookStatusColumn={true}
					/>
				</Stack>
			</Page>
		</Fragment>
	);
};
